export const SESSION_STORAGE_SHEET_KEY = 'program-sheet-ref';
